import axios from "axios";

export function setupAuth() {
  // Override window.fetch to include credentials (sends httpOnly cookie automatically)
  const AUTH_ENDPOINTS = [
    "/api/admin/user-role",
    "/api/admin/forgot-password",
    "/api/admin/reset-password",
  ];

  const isAuthEndpoint = (url) =>
    AUTH_ENDPOINTS.some((path) => String(url).includes(path));

  const originalFetch = window.fetch;
  window.fetch = (url, options = {}) => {
    options.credentials = "include";
    const token = localStorage.getItem("authToken");
    if (token) {
      options.headers = {
        Authorization: `Bearer ${token}`,
        ...options.headers,
      };
    }
    return originalFetch(url, options).then((response) => {
      if (response.status === 401 && !isAuthEndpoint(url)) {
        localStorage.removeItem("userData");
        localStorage.removeItem("authToken");
        window.location.replace("/sign-in");
      }
      return response;
    });
  };

  // Axios — send cookies and Authorization header on every request
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // Axios response interceptor — handle 401
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response?.status === 401 &&
        !isAuthEndpoint(error.config?.url)
      ) {
        localStorage.removeItem("userData");
        localStorage.removeItem("authToken");
        window.location.replace("/sign-in");
      }
      return Promise.reject(error);
    },
  );
}
